import { useState, useEffect, RefObject } from 'react';

export const useResizeObserver = (ref: RefObject<HTMLElement>) => {
  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    let resizeObserver: ResizeObserver | null = null;
    let cancelled = false;
    let rafId: number | null = null;

    const attach = () => {
      if (cancelled) return;

      const element = ref.current;
      if (!element) {
        rafId = window.requestAnimationFrame(attach);
        return;
      }

      const update = (rect?: DOMRectReadOnly) => {
        if (rect) {
          setSize({ width: rect.width, height: rect.height });
          return;
        }
        setSize({ width: element.offsetWidth, height: element.offsetHeight });
      };

      update();

      resizeObserver = new ResizeObserver((entries) => {
        update(entries[0]?.contentRect);
      });

      resizeObserver.observe(element);
    };

    attach();

    return () => {
      cancelled = true;
      if (rafId !== null) window.cancelAnimationFrame(rafId);
      resizeObserver?.disconnect();
    };
  }, [ref]);

  return size;
};
